// extracted by mini-css-extract-plugin
export default {"wrapper":"sendToBroadcasterSuccess_wrapper__9ChY7"};